(() => {
  const SUBSCRIPTION_CONTAINER = '.shopify_subscriptions_app_container[data-product-id]';
  let productPromise;
  let scheduled = false;

  function productJsonUrl() {
    const path = window.location.pathname.replace(/\/$/, '');
    return `${path}.js`;
  }

  function loadProduct() {
    if (!productPromise) {
      productPromise = fetch(productJsonUrl(), {
        headers: { Accept: 'application/json' }
      }).then((response) => {
        if (!response.ok) throw new Error(`Product JSON request failed: ${response.status}`);
        return response.json();
      });
    }

    return productPromise;
  }

  async function enableAvailableSellingPlans() {
    scheduled = false;

    const containers = [...document.querySelectorAll(SUBSCRIPTION_CONTAINER)];
    if (!containers.length) return;

    try {
      const product = await loadProduct();

      containers.forEach((container) => {
        if (String(container.dataset.productId) !== String(product.id)) return;

        container.querySelectorAll('section[data-variant-id]').forEach((section) => {
          const variant = product.variants?.find(
            (candidate) => String(candidate.id) === String(section.dataset.variantId)
          );

          if (!variant?.available) return;

          const availablePlanIds = new Set(
            (variant.selling_plan_allocations || []).map(
              (allocation) => String(allocation.selling_plan_id)
            )
          );

          section
            .querySelectorAll('input[data-radio-type="selling_plan"][data-selling-plan-id]')
            .forEach((input) => {
              if (!availablePlanIds.has(String(input.dataset.sellingPlanId))) return;

              input.disabled = false;
              input.removeAttribute('disabled');
              input.removeAttribute('aria-disabled');
              input.removeAttribute('data-variant-unavailable');
            });
        });
      });
    } catch (error) {
      console.warn('[DonCare] Subscription availability check failed.', error);
    }
  }

  function scheduleRepair() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(enableAvailableSellingPlans);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRepair, { once: true });
  } else {
    scheduleRepair();
  }

  document.addEventListener('shopify:section:load', scheduleRepair);

  new MutationObserver((mutations) => {
    const subscriptionWidgetAdded = mutations.some((mutation) =>
      [...mutation.addedNodes].some((node) =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches?.(SUBSCRIPTION_CONTAINER) || node.querySelector?.(SUBSCRIPTION_CONTAINER))
      )
    );

    if (subscriptionWidgetAdded) scheduleRepair();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

